import Pagination from '@/vuex/modules/pagination'
import Usuario from '@/vuex/modules/usuario'
import Captcha from '@/vuex/modules/captcha'
import Estado from '@/vuex/modules/estado'
import Cidade from '@/vuex/modules/cidade'
import TipoUsuarios from '@/vuex/modules/tipoUsuario'
import Modulo from '@/vuex/modules/modulo'
import Permissao from '@/vuex/modules/permissao'
import TokenEmail from '@/vuex/modules/token'

export default {
  modules: {
    usuario: Usuario,
    captcha: Captcha,
    estado: Estado,
    cidade: Cidade,
    tipoUsuarios: TipoUsuarios,
    token: TokenEmail,
    pagination: Pagination,
    modulo: Modulo,
    permissao: Permissao
  }
}



// WEBPACK FOOTER //
// ./src/vuex/store.js